<template>
  <modal 
    name="file-error-modal" 
    :pivotY="0.2"
    height="auto"
    @before-open="beforeOpen"
    :height="'auto'"
    :scrollable="true">
    
    <div class="modal-header">
      <div class="modal-title">
        Error
      </div>

      <a href="#"
        @click.prevent="$modal.hide('file-error-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body">
      <div class="text-sm">
        The file you tried to upload was bigger than 10MB. Please make sure that your
        document meets this limit.
      </div>
    </div>

    <div class="modal-footer">
      <SubmitButton2 label="Got it" :onClick="submit" :loading="loading" />
    </div>
  </modal>
</template>

<script>
  import SubmitButton2 from '@/shared/components/form/SubmitButton2'
  import { EventBus }  from '@/shared/event-bus'

  export default {

    components : {
      SubmitButton2
    },

    data() {
      return {
        loading          : false,
    //     categories       : null,
    //     documentTypes    : [],
    //     documentTypeError: null
      }
    },

    // mounted() {
    //   EventBus.$on('get-document-types', () => {
    //     this.getDocumentTypes()
    //   })
    // },

    // beforeDestroy() {
    //   EventBus.$off('get-document-types')
    // },

    methods : {
      beforeOpen(event) {
        // this.documentTypes = []
        // if(event.params.documents != null) {
        //   for(let i=0; i < event.params.documents.length; i++) {
        //     this.documentTypes.push(event.params.documents[i].document_type_id)
        //   }
        // }

        // this.getDocumentTypes()
      },

      submit() {
        this.$modal.hide('file-error-modal')
      },
    }
  }
</script>